(function () {
  // =========================
  // HERO SLIDESHOW (rechts rotierend)
  // =========================
  function initHeroSliders() {
    document.querySelectorAll("[data-ag-hero]").forEach((root) => {
      const slides = Array.from(root.querySelectorAll(".ag-hero__slide"));
      const dots = Array.from(root.querySelectorAll(".ag-hero__dot"));

      if (slides.length <= 1) return;

      let index = 0;
      const intervalMs = parseInt(root.getAttribute("data-interval"), 10) || 3500;

      function setActive(i) {
        slides.forEach((s, idx) => s.classList.toggle("is-active", idx === i));
        dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
        index = i;
      }

      dots.forEach((dot, i) => {
        dot.addEventListener("click", () => setActive(i));
      });

      setActive(0);

      let timer = setInterval(() => setActive((index + 1) % slides.length), intervalMs);

      root.addEventListener("mouseenter", () => clearInterval(timer));
      root.addEventListener("mouseleave", () => {
        clearInterval(timer);
        timer = setInterval(() => setActive((index + 1) % slides.length), intervalMs);
      });
    });
  }

  // =========================
  // HEADER BAR STICKY
  // =========================
  function initHeaderBarSticky() {
    const hdr = document.querySelector("[data-ag-header-bar]");
    if (!hdr) return;

    const topbar = document.querySelector(".ag-topbar");
    let spacer = document.querySelector("[data-ag-hdr-spacer]");

    if (!spacer) {
      spacer = document.createElement("div");
      spacer.setAttribute("data-ag-hdr-spacer", "");
      hdr.insertAdjacentElement("afterend", spacer);
    }

    function topbarHeight() {
      return topbar ? topbar.offsetHeight : 0;
    }

    function setFixed(on) {
      if (on) {
        const h = hdr.offsetHeight;
        hdr.classList.add("is-fixed");
        spacer.style.height = `${h}px`;
      } else {
        hdr.classList.remove("is-fixed");
        spacer.style.height = "0px";
      }
    }

    function onScroll() {
      const shouldFix = window.scrollY > topbarHeight();
      const isFixed = hdr.classList.contains("is-fixed");

      if (shouldFix !== isFixed) setFixed(shouldFix);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => {
      if (hdr.classList.contains("is-fixed")) {
        spacer.style.height = `${hdr.offsetHeight}px`;
      }
    });

    onScroll();
  }

  // =========================
  // WISHLIST (LocalStorage)
  // =========================
  const WKEY = "ag_wishlist_handles";

  function getWish() {
    try {
      return JSON.parse(localStorage.getItem(WKEY) || "[]");
    } catch {
      return [];
    }
  }

  function setWish(list) {
    localStorage.setItem(WKEY, JSON.stringify(list));
  }

  function refreshWishUI() {
    const list = getWish();

    document.querySelectorAll("[data-ag-wish]").forEach((btn) => {
      const handle = btn.getAttribute("data-handle");
      const active = list.includes(handle);

      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    document.querySelectorAll("[data-ag-wish-count]").forEach((el) => {
      if (list.length > 0) {
        el.textContent = String(list.length);
        el.style.display = "flex";
      } else {
        el.textContent = "";
        el.style.display = "none";
      }
    });
  }

  function initWishlist() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-ag-wish]");
      if (!btn) return;

      e.preventDefault();

      const handle = btn.getAttribute("data-handle");
      const list = getWish();
      const next = list.includes(handle)
        ? list.filter((h) => h !== handle)
        : [...list, handle];

      setWish(next);
      refreshWishUI();

      if (document.querySelector("[data-ag-wishlist-page]")) {
        renderWishlistPage();
      }
    });

    refreshWishUI();
  }

  // =========================
  // WISHLIST PAGE RENDER
  // =========================
  function renderWishlistPage() {
    const root = document.querySelector("[data-ag-wishlist-page]");
    if (!root) return;

    const empty = root.querySelector("[data-ag-wishlist-empty]");
    const items = Array.from(root.querySelectorAll("[data-ag-wish-item]"));
    const handles = getWish();

    if (!handles.length) {
      items.forEach((it) => (it.style.display = "none"));
      if (empty) empty.style.display = "block";
      return;
    }

    let shown = 0;

    items.forEach((it) => {
      const h = it.getAttribute("data-handle");
      const on = handles.includes(h);

      it.style.display = on ? "" : "none";
      if (on) shown++;
    });

    if (empty) empty.style.display = shown ? "none" : "block";

    refreshWishUI();
  }

  // =========================
  // CART COUNT
  // =========================
  async function updateCartCount() {
    try {
      const res = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
      });

      if (!res.ok) return;

      const cart = await res.json();
      const unique = Array.isArray(cart.items) ? cart.items.length : 0;

      document.querySelectorAll("[data-ag-cart-count]").forEach((el) => {
        if (unique > 0) {
          el.textContent = String(unique);
          el.style.display = "flex";
        } else {
          el.textContent = "";
          el.style.display = "none";
        }
      });
    } catch (e) {
      console.error("updateCartCount failed", e);
    }
  }
/*
  // =========================
  // SIMPLE SAMITA PRICE MIRROR
  // =========================
  function getSamitaPriceText(hook) {
    if (!hook) return "";

    const el = hook.querySelector(".samitaWS-customized-price");
    const txt = (el?.textContent || "").trim();

    return /\d/.test(txt) ? txt : "";
  }

  function syncSamitaPriceBox(box) {
    const root = box.closest("[data-ag-product],[data-ag-pdp]");
    const hook = root?.querySelector(".ag-ws-hook");
    const output = box.querySelector("[data-ag-samita-price]");

    if (!hook || !output) return;

    const txt = getSamitaPriceText(hook);
    if (!txt) return;

    output.textContent = txt;
    box.classList.remove("is-ws-loading");
    box.classList.add("is-ws-ready");
  }

  function initSamitaPricesSimple() {
    document.querySelectorAll("[data-ag-wsbox]").forEach((box) => {
      const root = box.closest("[data-ag-product],[data-ag-pdp]");
      const hook = root?.querySelector(".ag-ws-hook");

      if (!hook) return;

      syncSamitaPriceBox(box);

      if (hook.dataset.agObserved === "1") return;
      hook.dataset.agObserved = "1";

      const observer = new MutationObserver(() => {
        syncSamitaPriceBox(box);
      });

      observer.observe(hook, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  }
*/
  // =========================
  // QTY STEPPER + AJAX ATC
  // =========================
  function initQtyAndATC() {
    document.addEventListener("click", (e) => {
      const minus = e.target.closest("[data-ag-qty-minus]");
      const plus = e.target.closest("[data-ag-qty-plus]");

      if (!minus && !plus) return;

      const wrap = e.target.closest("[data-ag-qtywrap]");
      if (!wrap) return;

      const input = wrap.querySelector("input[data-ag-qty]");
      if (!input) return;

      const current = parseInt(input.value || "1", 10) || 1;
      const min = parseInt(input.getAttribute("min") || "1", 10) || 1;
      const max = parseInt(input.getAttribute("max") || "9999", 10) || 9999;

      let next = current;

      if (minus) next = Math.max(min, current - 1);
      if (plus) next = Math.min(max, current + 1);

      input.value = String(next);
    });

    document.addEventListener("click", async (e) => {
      const btn = e.target.closest("[data-ag-atc]");
      if (!btn) return;

      e.preventDefault();

      const variantId = btn.getAttribute("data-variant");
      if (!variantId) return;

      const container =
        btn.closest("[data-ag-product]") || btn.closest("[data-ag-pdp]");
      const qtyInput = container
        ? container.querySelector("input[data-ag-qty]")
        : null;
      const quantity = qtyInput ? parseInt(qtyInput.value || "1", 10) || 1 : 1;

      btn.disabled = true;
      btn.classList.add("is-loading");

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity,
          }),
        });

        if (!res.ok) throw new Error("ATC failed");

        await updateCartCount();

        btn.classList.add("is-added");
        setTimeout(() => btn.classList.remove("is-added"), 900);
      } catch (err) {
        console.error(err);
        alert("Konnte nicht in den Warenkorb legen. Bitte erneut versuchen.");
      } finally {
        btn.disabled = false;
        btn.classList.remove("is-loading");
      }
    });
  }

  // =========================
  // COLLECTION SEARCH
  // =========================
  function initClientSearch() {
    document.querySelectorAll("[data-ag-search]").forEach((wrap) => {
      const input = wrap.querySelector("input");
      const gridSel = wrap.getAttribute("data-target") || "[data-ag-grid]";
      const grid = document.querySelector(gridSel);

      if (!input || !grid) return;

      input.addEventListener("input", () => {
        const q = (input.value || "").trim().toLowerCase();

        grid.querySelectorAll("[data-ag-product]").forEach((card) => {
          const hay = (card.getAttribute("data-title") || "").toLowerCase();
          card.style.display = hay.includes(q) ? "" : "none";
        });
      });
    });
  }

  // =========================
  // BOOT
  // =========================
  function bootAG() {
    initHeroSliders();
    initWishlist();
    initQtyAndATC();
    initClientSearch();
    updateCartCount();
    initHeaderBarSticky();
    //initSamitaPricesSimple();

    if (document.querySelector("[data-ag-wishlist-page]")) {
      renderWishlistPage();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAG);
  } else {
    bootAG();
  }

  window.addEventListener("load", initSamitaPricesSimple);
  window.addEventListener("pageshow", initSamitaPricesSimple);
  document.addEventListener("shopify:section:load", initSamitaPricesSimple);
})();